import React from 'react';
import moment from 'moment';
import { message, Row } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';
import { CLIENTE_VARIOS } from '../../../common/types/clienteType';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { COTIZACION } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { RUC, OTROS } from '../../../common/types/tipoDocumentoType';
import usuarioService from '../../../service/seguridad/usuarioService';
import contactoService from '../../../service/administracion/contactoService';
import empresaService from '../../../service/administracion/empresaService';

import {
    VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
    VENTA_MODIFICAR_TOTAL_PRODUCTO,
    VENTA_BLOQUEAR_IMPUESTOS,
    CONVERSION_MEDIDA,
    VER_HISTORIAL_COTI
} from "../../../common/types/parametroType";
import printFormatMock from '../../../common/mock/printFormatMock';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';
import { lst_tipo_impuesto } from "../../../common/types/impuestoType";

import proyectoService from '../../../service/administracion/proyectoService';
import comprobanteService from '../../../service/ventas/comprobanteService';
import cotizacionService from '../../../service/ventas/cotizacionService';
import monedaService from '../../../service/administracion/monedaService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import vendedorService from '../../../service/administracion/vendedorService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import detraccionService from '../../../service/administracion/detraccionService';
import clienteService from '../../../service/administracion/clienteService';
import vehiculoService from '../../../service/logistica/vehiculoService';
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';
import fenologicaService from '../../../service/administracion/fenologicaService';
import cultivoService from '../../../service/administracion/cultivoService';


import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import EditarNombreProductoModal from '../Seguimiento/EditarNombreProductoModal';
import SearchProductModal from '../../../components/SearchProductModal';
import ViewModal from '../Seguimiento/ViewModal';
import ImprimirModal from '../Seguimiento/ImprimirModal';
import CorreoModal from '../Seguimiento/CorreoModal';

import { VENTA } from '../../../common/types/moduloType';
import { VER_HISTORIAL_COTIZACION, VER_SERIES_VENTA } from '../../../common/types/configuracionType';
import FormHistorial from './FormHistorial';
import CondicionComercialModal from './CondicionComercialModal';
import { lst_tipo_afectacion } from '../../../common/types/tipoAfectacion';


var referenciaCount = 1;


export default class Index extends PaginationBase {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingNew: false,
            loadingSource: true,
            loadingCopy: false,
            loadingImprimir: false,
            loadingPdf: false,
            loadingExcel: false,
            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            productos: [],
            detracciones: [],
            proyectos: [],
            estado: [],
            contactos: [],
            permisosUsuario: [],
            configuraciones: [],
            cultivos: [],
            company: {},

            filter: {
                idTipoComprobante: COTIZACION.ID,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                serie: '',
                idEstado: 0,
                cliente: '',
                documento: '',
                idVendedor: 0,
                flagAprobado: false,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            historialVisible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: []
            },
            editarNombreProductoFormValues: {
                id: '',
                nombre: ''
            },
            editarCondicionComercial: {
                id: '',
                nombre: ''
            },
            onSetFieldsValue: null,
            onGetFieldValue: null,
            searchProductVisible: false,
            searchProductFormValues: {
                validarStock: false,
                precioUnitInclyIGV: false,
                dataSource: []
            },
            emitirVisible: false,
            emitirFilePdf: undefined,
            imprimirVisible: false,
            imprimirFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                isEpson: false,
                formatos: printFormatMock.values
            },
            correoFormValues: {
                file: undefined,
                id: 0,
                correoCliente: ''
            },
            cdrVisible: false,
            selectedItem: {},
            viewVisible: false,
            viewFormValues: {},
            historialSource: []
        }
    };


    fetchEmptyFormValues = (objEdit) => {
        return {
            id: objEdit !== undefined ? objEdit.cotizacion.id : 0,
            idTipoComprobante: COTIZACION.ID,
            idCliente: objEdit !== undefined ? objEdit.cotizacion.idCliente : 0,
            idEstablecimientoCliente: objEdit !== undefined ? objEdit.cotizacion.idEstablecimientoCliente : 0,
            // idProyecto: 0
            idVendedor: objEdit !== undefined ? objEdit.cotizacion.idVendedor : 0,
            idAlmacen: objEdit !== undefined ? objEdit.cotizacion.idAlmacen : 0,
            idMoneda: objEdit !== undefined ? objEdit.cotizacion.idMoneda : SOLES,
            idListaPrecio: objEdit !== undefined ? objEdit.cotizacion.idListaPrecio : 0,
            idProyecto: objEdit !== undefined ? objEdit.cotizacion.idProyecto : 0,
            // idComprobanteEstado: 0,
            idEstablecimiento: objEdit !== undefined ? objEdit.cotizacion.idEstablecimiento : 0,
            idDetraccion: 0,
            idUsuarioRegistro: auth.user().id,
            serie: objEdit !== undefined ? objEdit.cotizacion.serie : "",
            documento: objEdit !== undefined ? objEdit.cotizacion.documento : "",
            fechaStr: objEdit !== undefined ? objEdit.cotizacion.fechaStr : global.fetchCurrentDateStr(),
            fechaVencimientoStr: objEdit !== undefined ? objEdit.cotizacion.fechaVencimientoStr : global.fetchCurrentDateStr(),
            diasVencimiento: objEdit !== undefined ? objEdit.cotizacion.diasVencimiento : 0,
            numeroPlaca: "",
            condicion: objEdit !== undefined ? objEdit.cotizacion.condicion : "",
            plazo: objEdit !== undefined ? objEdit.cotizacion.plazo : "",
            condicionComercial: objEdit !== undefined ? objEdit.cotizacion.condicionComercial : "",

            idVehiculo: objEdit !== undefined ? objEdit.cotizacion.idVehiculo : 0,
            encargado: objEdit !== undefined ? objEdit.cotizacion.encargado : "",

            tipoCambio: objEdit !== undefined ? objEdit.cotizacion.tipoCambio : 0,
            observacion: objEdit !== undefined ? objEdit.cotizacion.observacion : "",
            flagExportacion: false,
            flagPercepcion: false,
            flagDetraccion: false,
            flagImpresion: objEdit !== undefined ? objEdit.cotizacion.flagImpresion : false,
            idContacto: objEdit !== undefined ? objEdit.cotizacion.idContacto : 0,

            // flagAnticipo: false,
            flagGrifo: false,
            flagImpuesto: auth.user().parametros.filter(m => m.abreviatura === VENTA_BLOQUEAR_IMPUESTOS)[0].valor === "1" ? true : false,
            otroImpuesto: objEdit !== undefined ? objEdit.cotizacion.tipoImpuesto : 1,

            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            cultivos: [],
            fenologicas: [],
            /*********************/
            sumaTotalDetalle: objEdit !== undefined ? objEdit.cotizacion.totalDetalle : 0,
            sumaImporteDescuento: objEdit !== undefined ? objEdit.cotizacion.importeDescuento : 0,
            sumaSubTotal: objEdit !== undefined ? objEdit.cotizacion.subTotal : 0,
            sumaIgv: objEdit !== undefined ? objEdit.cotizacion.igv : 0,
            sumaIsc: objEdit !== undefined ? objEdit.cotizacion.isc : 0,
            sumaTotal: objEdit !== undefined ? objEdit.cotizacion.total : 0,
            porcentajeDetraccion: 0,
            importeDetraccion: 0,
            totalDetraccion: 0,
            porcentajePercepcion: 0,
            importePercepcion: 0,
            totalPercepcion: 0,
            flagEmpresaTaller: false,
            precioUnitarioDetailDisabled: false,
            totalDetailDisabled: auth.user().parametros.filter(m => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO)[0].valor === "1" ? false : true,
            flagEmpresaGrifo: false,
            flagClaim: false,
            modelo: objEdit !== undefined ? objEdit.cotizacion.modelo : "",
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            documentoCliente: objEdit !== undefined ? objEdit.cotizacion.numeroDocumentoCliente : "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            detracciones: [],
            detalleProductos: [],
            proyectos: [],
            contactos: [],
            vehiculos: [],
            Tipoimpuesto: lst_tipo_impuesto,
            idTipoPrecio: [],
            idCultivo: objEdit !== undefined ? objEdit.cotizacion.idCultivo : 0,
            idFenologica: objEdit !== undefined ? objEdit.cotizacion.idFenologica : 0,
        }
    };

    handleClearFilters = () => {
        var filter = {
            idTipoComprobante: COTIZACION.ID,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            serie: this.state.filter.serie,
            documento: '',
            flagAprobado: false,
            cliente: '',
            idEstado: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await cotizacionService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Cotizaciones.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await cotizacionService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Cotizaciones.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await cotizacionService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleImprimir = async (item) => {
        this.setState({ loadingImprimir: true });

        var file = undefined;
        var idFormato = this.state.company.formatoPrint;
        var isEpson = JSON.parse(localStorage.getItem("isEpson"));

        var response;
        if (idFormato === 1) {
            response = await cotizacionService.pdfA4({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await cotizacionService.ticket({
                id: item.id,
                isEpson: isEpson == null ? false : isEpson
            });
            file = window.URL.createObjectURL(response.data);
        }
        if (idFormato === 3) {
            response = await cotizacionService.ticket58({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirVisible: true,
            loadingImprimir: false,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                fileName: item.serie + '-' + item.documento,
                idComprobante: item.id
            }
        });
    };


    handleSwitch = async (e) => {
        localStorage.setItem("isEpson", JSON.stringify(e))
        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                isEpson: e,
            }
        })

        setTimeout(() => {
            this.handleChangeImprimir(2)
        }, 100);
    }
    handleChangeImprimir = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        if (idFormato === 1) {
            response = await cotizacionService.pdfA4({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await cotizacionService.ticket({
                id: this.state.imprimirFormValues.idComprobante,
                isEpson: JSON.parse(localStorage.getItem("isEpson")),
            });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await cotizacionService.ticket58({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                isEpson: JSON.parse(localStorage.getItem("isEpson"))
            }
        });
    };

    handleDownloadPdf = async () => {
        var response = undefined;
        var file = undefined;
        /*    
               if (this.state.imprimirFormValues.idFormato === 1) {
                 response = await cotizacionService.pdfA4({
                   id: this.state.imprimirFormValues.idComprobante,
                 });
                 file = window.URL.createObjectURL(response.data);
               }
           
               if (this.state.imprimirFormValues.idFormato === 2) {
                 response = await cotizacionService.ticket({
                   id: this.state.imprimirFormValues.idComprobante,
                 });
                 file = window.URL.createObjectURL(response.data);
               }
           
               if (this.state.imprimirFormValues.idFormato === 3) {
                 response = await cotizacionService.ticket50({
                   id: this.state.imprimirFormValues.idComprobante,
                 });
                 file = window.URL.createObjectURL(response.data);
               }
           
               if (response !== undefined)
                 global.dowloadFile(
                   response.data,
                   this.state.imprimirFormValues.fileName + ".pdf"
                 ); */

        global.downloadFileBlob(this.state.imprimirFormValues.file, this.state.imprimirFormValues.fileName + ".pdf");

    };

    handleCorreo = async (item) => {
        //var response = await cotizacionService.pdfA4({ id: item.id });
        var file = undefined;// window.URL.createObjectURL(response.data);
        this.setState({
            correoVisible: true,
            correoFormValues: {
                ...this.state.correoFormValues,
                file,
                id: item.id,
                correoCliente: item.correoCliente
            }
        });
    };

    handleEnviarCorreo = async (data, form) => {
        dialog.confirm('¿Desea enviar el correo?', async () => {
            var response = await cotizacionService.enviarCorreo(data);

            if (response.status === 200) {
                form.resetFields();
                dialog.success('El correo ha sido enviado.');
                this.setState({ correoVisible: false });
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/
    handleView = async (item) => {
        var response = await cotizacionService.ver({ id: item.id });
        if (response !== undefined) {
            this.setState({
                viewVisible: true,
                viewFormValues: response
            });
        }
    }

    handleEdit = async (item) => {
        this.setState({ loadingEdit: true });

        const response = await cotizacionService.obtenerPorId(item.id);
        this.setState({ loadingEdit: false });

        if (response === undefined) {
            dialog.error("Ocurrió un error mientras se obtenia los datos.");
            return;
        }
        var params = auth.user().parametros;
        var conversionMedida = params.filter((m) => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;

        var flagPrecioIncluyeIGV = params.filter((m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1"
            ? true
            : false;
        var formValues = this.fetchEmptyFormValues(response);
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
        formValues.establecimientos = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.establecimientos;
        formValues.vendedores = this.state.vendedores;
        formValues.tiposComprobante = this.state.tiposComprobante;

        formValues.flagGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.flagEmpresaGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.flagClaim = this.state.company.idTipoEmpresa == 2 ? true : false;

        if (response.cotizacion.idListaPrecio == 0 || response.cotizacion.idListaPrecio == undefined) {
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        }
        formValues.detracciones = this.state.detracciones;
        formValues.clientes = this.state.clientes;
        formValues.proyectos = this.state.proyectos;
        formValues.tipoAfectacion = lst_tipo_afectacion;

        // conversion de medida por lista de precio
        formValues.idTipoPrecio = this.state.listasPrecio.filter((m) => m.id == formValues.idListaPrecio);
        const productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
        const direcciones = await establecimientoService.listarPorIdEntidad(response.cotizacion.idEntidadCliente);
        var almacenes = await almacenService.listarPorIdEstablecimiento(response.cotizacion.idEstablecimiento);
        const vehiculos = await vehiculoService.obtenerPorClienteId(formValues.idCliente);

        const fenologicas = formValues.idCultivo == 0 ? [] : await fenologicaService.obtenerPorCultivoId(formValues.idCultivo);

        var contactos = await contactoService.listarPorIdEntidad(formValues.idCliente);
        formValues.contactos = contactos;

        if (almacenes != undefined && this.state.permisosUsuario.length > 0) {
            var newArray = new Array();
            var valido = false;
            var esta = formValues.establecimientos.filter(data => data.id == formValues.idEstablecimiento);

            this.state.permisosUsuario.forEach(e => {
                var regg = almacenes.filter(data => data.id == e.idAlmacen);
                if (regg.length > 0) {
                    var item = {
                        direccion: regg[0].direccion,
                        id: regg[0].id,
                        idTipoAlmacen: regg[0].idTipoAlmacen,
                        nombre: regg[0].nombre
                    }
                    newArray.push(item);
                    if (formValues.idAlmacen == regg[0].id) {
                        valido = true
                    }
                }
            });
            almacenes = newArray;
            formValues.idAlmacen = valido ? formValues.idAlmacen : null;
            formValues.idEstablecimiento = esta.length == 0 ? null : formValues.idEstablecimiento;
            formValues.idListaPrecio = esta.length == 0 ? null : formValues.idListaPrecio;

        }

        response.cotizacionDetalles.forEach(row => {
            const identifier = global.fetchUniqueCode();

            var itemsConversion = [];
            if (conversionMedida) {
                itemsConversion = row.itemConversion == null ? [] : JSON.parse(row.itemConversion);
            }
            formValues.listaComprobanteDetalle.push(
                {
                    identifier: identifier,
                    idProducto: row.idProducto,
                    idTipoProducto: row.idTipoProducto,
                    codigo: row.codigoReferencia,
                    nombre: row.nombre,
                    numeroLote: row.numeroLote,
                    precioPromedio: row.precioPromedio,
                    porcentajeMargenComercial: row.porcentajeMargenComercial,
                    nombreUnidadMedida: row.nombreUnidadMedida,
                    idUnidadMedida: row.idUnidadMedida,
                    flagAfecto: row.flagAfecto,
                    flagGratuito: row.flagGratuito,
                    flagISC: row.flagISC,
                    isc: row.importeISC,
                    precioUnitario: flagPrecioIncluyeIGV ? row.precioUnitario : row.precioUnitarioSinIGV,
                    precioUnitarioSinIGV: row.precioUnitarioSinIGV,
                    cantidad: row.cantidad,
                    totalDetalle: row.totalDetalle,
                    porcentajeDescuento: row.porcentajeDescuento,
                    importeDescuento: row.importeDescuento,
                    subTotal: row.subTotal,
                    igv: row.igv,
                    total: row.total,
                    flagConversion: row.flagConversion,
                    idImpuesto: row.idImpuesto,
                    itemConversion: itemsConversion ? itemsConversion : [],
                    flagVencimiento: row.flagVencimiento,
                    fechaVencimientoStr: row.flagVencimiento ? row.fechaVencimientoStr : null
                }
            );
            const element = row;
            formValues.detalleProductos.push({
                identifier: identifier,
                idProducto: element.idProducto,
                idTipoProducto: row.idTipoProducto,
                nombre: element.nombre,
                numeroLote: row.numeroLote,
                idUnidadMedida: row.idUnidadMedida,
                precioPromedio: row.precioPromedio,
                porcentajeMargenComercial: row.porcentajeMargenComercial,
                cantidad: element.cantidad,
                precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                precioUnitario: flagPrecioIncluyeIGV ? element.precioUnitario : element.precioUnitarioSinIGV,
                porcentajeDescuento: element.porcentajeDescuento,
                importeDescuento: element.importeDescuento,
                total: element.total,
                flagAfecto: element.flagAfecto,
                flagISC: element.flagISC,
                flagOtrosImpuesto: element.flagOtrosImpuesto,
                flagGratuito: element.flagGratuito,
                flagChangeTotal: element.flagChangeTotal,
                subTotal: element.subTotal,
                idImpuesto: element.idImpuesto,
                flagConversion: row.flagConversion,
                itemConversion: itemsConversion ? itemsConversion : [],
                flagVencimiento: row.flagVencimiento,
                fechaVencimientoStr: row.flagVencimiento ? row.fechaVencimientoStr : null
            });
        });

        response.cotizacionReferencias.forEach(element => {
            formValues.listaComprobanteReferencia.push({
                identifier: global.fetchUniqueCode(),
                idTipoComprobante: element.idTipoComprobante,
                serie: element.serie,
                documento: element.documento
            });
        });

        formValues.direcciones = direcciones;
        formValues.almacenes = almacenes;
        formValues.vehiculos = vehiculos;
        formValues.fenologicas = fenologicas;
        formValues.cultivos = this.state.cultivos;


        this.setState({
            // loadingNew: false,
            visible: true,
            formValues,
            productos: productos ? productos : []
        });

    }

    handleCopy = async (item) => {
        this.setState({ loadingCopy: true });
        const response = await cotizacionService.obtenerPorId(item.id);
        if (response === undefined) {
            this.setState({ loadingCopy: false });
            dialog.error("Ocurrió un error mientras se obtenia los datos.");
            return;
        }

        var params = auth.user().parametros;
        var conversionMedida = params.filter((m) => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;

        var flagPrecioIncluyeIGV = params.filter((m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1"
            ? true
            : false;
        response.cotizacion.id = 0;
        var formValues = this.fetchEmptyFormValues(response);
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
        formValues.establecimientos = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.establecimientos;
        formValues.vendedores = this.state.vendedores;
        formValues.tiposComprobante = this.state.tiposComprobante;
        if (response.cotizacion.idListaPrecio == 0 || response.cotizacion.idListaPrecio == undefined) {
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        }
        formValues.detracciones = this.state.detracciones;
        formValues.clientes = this.state.clientes;
        formValues.proyectos = this.state.proyectos;
        formValues.otroImpuesto = 1;
        formValues.idProyecto = 0;
        const productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
        const direcciones = await establecimientoService.listarPorIdEntidad(response.cotizacion.idEntidadCliente);
        var almacenes = await almacenService.listarPorIdEstablecimiento(response.cotizacion.idEstablecimiento);
        const vehiculos = await vehiculoService.obtenerPorClienteId(formValues.idCliente);
        // conversion de medida por lista de precio
        formValues.idTipoPrecio = this.state.listasPrecio.filter((m) => m.id == formValues.idListaPrecio);
        const fenologicas = formValues.idCultivo == 0 ? [] : await fenologicaService.obtenerPorCultivoId(formValues.idCultivo);


        var contactos = await contactoService.listarPorIdEntidad(formValues.idCliente);
        formValues.contactos = contactos;


        if (almacenes != undefined && this.state.permisosUsuario.length > 0) {
            var newArray = new Array();
            var valido = false;
            var esta = formValues.establecimientos.filter(data => data.id == formValues.idEstablecimiento);

            this.state.permisosUsuario.forEach(e => {
                var regg = almacenes.filter(data => data.id == e.idAlmacen);
                if (regg.length > 0) {
                    var item = {
                        direccion: regg[0].direccion,
                        id: regg[0].id,
                        idTipoAlmacen: regg[0].idTipoAlmacen,
                        nombre: regg[0].nombre
                    }
                    newArray.push(item);
                    if (formValues.idAlmacen == regg[0].id) {
                        valido = true
                    }
                }
            });
            almacenes = newArray;
            formValues.idAlmacen = valido ? formValues.idAlmacen : null;
            formValues.idEstablecimiento = esta.length == 0 ? null : formValues.idEstablecimiento;
            formValues.idListaPrecio = esta.length == 0 ? null : formValues.idListaPrecio;

        }

        response.cotizacionDetalles.forEach(row => {
            const identifier = global.fetchUniqueCode();

            var itemsConversion = [];
            if (conversionMedida) {
                itemsConversion = row.itemConversion == null ? [] : JSON.parse(row.itemConversion);
            }
            formValues.listaComprobanteDetalle.push(
                {
                    identifier: identifier,
                    idProducto: row.idProducto,
                    idTipoProducto: row.idTipoProducto,
                    codigo: row.codigoReferencia,
                    nombre: row.nombre,
                    numeroLote: row.numeroLote,
                    precioPromedio: row.precioPromedio,
                    porcentajeMargenComercial: row.porcentajeMargenComercial,
                    nombreUnidadMedida: row.nombreUnidadMedida,
                    idUnidadMedida: row.idUnidadMedida,
                    flagAfecto: row.flagAfecto,
                    flagGratuito: row.flagGratuito,
                    flagISC: row.flagISC,
                    isc: row.importeISC,
                    precioUnitario: flagPrecioIncluyeIGV ? row.precioUnitario : row.precioUnitarioSinIGV,
                    precioUnitarioSinIGV: row.precioUnitarioSinIGV,
                    cantidad: row.cantidad,
                    totalDetalle: row.totalDetalle,
                    porcentajeDescuento: row.porcentajeDescuento,
                    importeDescuento: row.importeDescuento,
                    subTotal: row.subTotal,
                    igv: row.igv,
                    total: row.total,
                    idImpuesto: row.idImpuesto,
                    flagConversion: row.flagConversion,
                    itemConversion: itemsConversion ? itemsConversion : [],
                    flagVencimiento: row.flagVencimiento,
                    fechaVencimientoStr: row.flagVencimiento ? row.fechaVencimientoStr : null
                }
            );
            const element = row;
            formValues.detalleProductos.push({
                identifier: identifier,
                idProducto: element.idProducto,
                idTipoProducto: row.idTipoProducto,
                nombre: element.nombre,
                numeroLote: row.numeroLote,
                idUnidadMedida: row.idUnidadMedida,
                precioPromedio: row.precioPromedio,
                porcentajeMargenComercial: row.porcentajeMargenComercial,
                cantidad: element.cantidad,
                precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                precioUnitario: flagPrecioIncluyeIGV ? element.precioUnitario : element.precioUnitarioSinIGV,
                porcentajeDescuento: element.porcentajeDescuento,
                importeDescuento: element.importeDescuento,
                total: element.total,
                flagAfecto: element.flagAfecto,
                flagISC: element.flagISC,
                flagOtrosImpuesto: element.flagOtrosImpuesto,
                flagGratuito: element.flagGratuito,
                flagChangeTotal: element.flagChangeTotal,
                subTotal: element.subTotal,
                idImpuesto: element.idImpuesto,
                flagConversion: row.flagConversion,
                itemConversion: itemsConversion ? itemsConversion : [],
                flagVencimiento: row.flagVencimiento,
                fechaVencimientoStr: row.flagVencimiento ? row.fechaVencimientoStr : null
            });
        });



        formValues.direcciones = direcciones;
        formValues.almacenes = almacenes;
        formValues.vehiculos = vehiculos;
        formValues.fenologicas = fenologicas;
        formValues.cultivos = this.state.cultivos;
        formValues.tipoAfectacion = lst_tipo_afectacion;


        this.setState({
            // loadingNew: false,
            visible: true,
            formValues,
            productos: productos ? productos : [],
            loadingCopy: false
        });


    }

    handleNew = async () => {
        this.setState({ loadingNew: true });

        var formValues = this.fetchEmptyFormValues();
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.establecimientos = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.establecimientos;
        formValues.vendedores = this.state.vendedores;
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.detracciones = this.state.detracciones;
        formValues.clientes = this.state.clientes;
        formValues.proyectos = this.state.proyectos;
        formValues.cultivos = this.state.cultivos;
        formValues.contactos = this.state.contactos;

        formValues.flagGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.flagEmpresaGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.flagClaim = this.state.company.idTipoEmpresa == 2 ? true : false;
        formValues.tipoAfectacion = lst_tipo_afectacion;

        var cliente_varios = formValues.clientes.filter(m => m.id === CLIENTE_VARIOS);
        if (cliente_varios.length !== 0) {
            formValues.idCliente = CLIENTE_VARIOS;
            const direcciones = await establecimientoService.listarPorIdEntidad(cliente_varios[0].idEntidad);
            formValues.documentoCliente = cliente_varios[0].numeroDocumento;
            formValues.direcciones = direcciones ? direcciones : [];
            formValues.idEstablecimientoCliente = direcciones.length > 0 ? direcciones[0].id : undefined;
        }

        //const productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);  
        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: COTIZACION.ID
        }

        const datosIniciales = await cotizacionService.datosIniciales(datosInicialesFilter);

        if (datosIniciales !== undefined) {
            formValues.idVendedor = datosIniciales.idVendedor;
            formValues.idAlmacen = datosIniciales.idAlmacen;
            formValues.idEstablecimiento = datosIniciales.idEstablecimiento;
            formValues.idListaPrecio = datosIniciales.idListaPrecio;
            formValues.serie = datosIniciales.serie;
            formValues.condicionComercial = datosIniciales.condicionComercial;
        }

        if (formValues.idEstablecimiento > 0) {
            const almacenes = await await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
            var esta = formValues.establecimientos.filter(data => data.id == formValues.idEstablecimiento);

            var almacenFilter = almacenes.filter(almacen => almacen.idTipoAlmacen == 1);
            if (almacenFilter != undefined && this.state.permisosUsuario.length > 0) {
                var newArray = new Array();
                this.state.permisosUsuario.forEach(e => {
                    var regg = almacenFilter.filter(data => data.id == e.idAlmacen);
                    if (regg.length > 0) {
                        var item = {
                            direccion: regg[0].direccion,
                            id: regg[0].id,
                            idTipoAlmacen: regg[0].idTipoAlmacen,
                            nombre: regg[0].nombre
                        }
                        newArray.push(item);
                    }

                });
                almacenFilter = newArray;

                formValues.idEstablecimiento = esta.length == 0 ? null : formValues.idEstablecimiento;
                formValues.idAlmacen = esta.length == 0 ? null : formValues.idAlmacen;
                formValues.idListaPrecio = esta.length == 0 ? null : formValues.idListaPrecio;
            }
            const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
            formValues.almacenes = almacenFilter ? almacenFilter : [];
            formValues.listasPrecio = listasPrecio ? listasPrecio : [];
        }

        if (formValues.serie == "" || formValues.serie == null) {
            setTimeout(() => {
                dialog.error("Tiene que registrar serie correlativo para poder emitir el documento");

            }, 100);

        } else {

            this.setState({
                loadingNew: false,
                visible: true,
                formValues,
                //productos: productos ? productos : []
            });
        }


    };

    handleEstablecimiento = () => {
        var newEstablecimiento = new Array();

        if (this.state.permisosUsuario.length == 0) {
            return newEstablecimiento;
        } else {
            //return establecimiento group by
            const Oreturn = this.handleGroupBy(this.state.permisosUsuario);

            Oreturn.forEach(element => {
                var obj = this.state.establecimientos.filter(m => m.id == element);
                if (obj.length > 0) {
                    var item = {
                        codigoSunat: obj[0].codigoSunat,
                        direccion: obj[0].direccion,
                        id: obj[0].id,
                        idDepartamento: obj[0].idDepartamento,
                        idProvincia: obj[0].idProvincia,
                        idTipoEstablecimiento: obj[0].idTipoEstablecimiento,
                        idUbigeo: obj[0].idUbigeo,
                        nombre: obj[0].nombre,
                        nombreTipoEstablecimiento: obj[0].nombreTipoEstablecimiento
                    }
                    newEstablecimiento.push(item);

                }
            });

        }
        return newEstablecimiento;
    }

    handleGroupBy(array) {
        var lista = new Array();
        array.forEach(element => {
            lista.push(element.idEstablecimiento);
        });

        return lista.filter((item, index) => lista.indexOf(item) === index);
    }


    handleSave = async (item, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (item.id === 0)
                response = await cotizacionService.registrar(item);
            else
                response = await cotizacionService.modificar(item);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((item.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    };

    handleChangeForm = async (property, value, form) => {


        if (property === "fechaStr") {
            const fecha = moment(value, 'DD/MM/YYYY');
            const fechaVencimiento = moment(form.getFieldValue('fechaVencimientoStr'), 'DD/MM/YYYY');
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            form.setFieldsValue({
                tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
                diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString()
            });
        }

        if (property === "idCliente") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value.split("-")[0]);
            var vehiculos = await vehiculoService.obtenerPorClienteId(value.split("-")[1]);
            vehiculos = vehiculos.filter(e => e.flag);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direcciones ? direcciones : [],
                    vehiculos: vehiculos ? vehiculos : [],
                    idContacto: 0
                }
            }, () => {
                form.setFieldsValue({
                    idEstablecimientoCliente: { key: direcciones.length > 0 ? direcciones[0].id : undefined },
                    idVehiculo: { key: vehiculos.length > 0 ? vehiculos[0].id : undefined },
                    idContacto: { key: undefined },

                });
            });
        }

        if (property === "idCultivo") {
            const fenologicas = await fenologicaService.obtenerPorCultivoId(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    fenologicas: fenologicas ? fenologicas : [],
                }
            },
                () => {
                    form.setFieldsValue({
                        idFenologica: {
                            key: undefined,
                        },
                    });
                }
            );
        }

        if (property == "otroImpuesto") {
            var data = form.getFieldValue(property);

            if (this.state.formValues.listaComprobanteDetalle.length > 0) {

                dialog.confirm(
                    <span>
                        Al cambiar el tipo de impuesto se removera los productos agregados previamente.
                        <br />
                        <span>¿Deseas continuar?'</span>
                    </span>,
                    async () => {

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                                detalleProductos: [],
                                listaComprobanteReferencia: [],
                            },
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0,
                            porcentajeDetraccion: 0,
                            importeDetraccion: 0,
                            totalDetraccion: 0,
                            porcentajePercepcion: 0,
                            importePercepcion: 0,
                            totalPercepcion: 0,
                            detalleProductos: [],
                            listaComprobanteDetalle: [],
                        });
                    },
                    () =>
                        form.setFieldsValue({
                            [property]: data,
                        })
                );
            }
        }



        if (property === "direcciones-clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: [],
                    idVehiculo: undefined,

                }
            })
        }

        if (property === "idEstablecimiento" || property === "idListaPrecio" || property === "idAlmacen") {
            var data = form.getFieldValue(property);
            var label = property === "idEstablecimiento" ? "el establecimiento" : property === "idListaPrecio" ? "la lista de precio" : "el almacén";
            if (this.state.formValues.listaComprobanteDetalle.length > 0) {
                dialog.confirm(<span>Al cambiar {label} se removera los productos agregados previamente.<br /><span>¿Deseas continuar?'</span></span>,
                    async () => {
                        if (property === "idEstablecimiento") {

                            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                            var almacenes = await almacenService.listarPorIdEstablecimiento(value);
                            if (almacenes != undefined && this.state.permisosUsuario.length > 0) {
                                var newArray = new Array();
                                this.state.permisosUsuario.forEach(e => {
                                    var regg = almacenes.filter(data => data.id == e.idAlmacen);
                                    if (regg.length > 0) {
                                        var item = {
                                            direccion: regg[0].direccion,
                                            id: regg[0].id,
                                            idTipoAlmacen: regg[0].idTipoAlmacen,
                                            nombre: regg[0].nombre
                                        }
                                        newArray.push(item);
                                    }

                                });
                                almacenes = newArray;
                            }

                            const listasPrecio = this.state.listasPrecio.filter(
                                (m) => m.idEstablecimiento === value
                            );
                            this.setState({
                                formValues: {
                                    ...this.state.formValues,
                                    almacenLoading: false,
                                    almacenes: almacenes ? almacenes : [],
                                    listasPrecio: listasPrecio ? listasPrecio : []
                                }
                            });
                            form.setFieldsValue({
                                detalleProductos: [],
                                idAlmacen: undefined,
                                idListaPrecio: undefined
                            });
                        }

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                                detalleProductos: [],
                                listaComprobanteReferencia: [],
                            }
                        });

                        form.setFieldsValue({
                            detalleProductos: [],
                            listaComprobanteDetalle: [],
                            listaComprobanteReferencia: [],

                        });
                    }, () => form.setFieldsValue({ [property]: data, detalleProductos: [] }));
            } else {

                if (property === "idEstablecimiento") {

                    this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                    var almacenes = await almacenService.listarPorIdEstablecimiento(value);
                    if (almacenes != undefined && this.state.permisosUsuario.length > 0) {
                        var newArray = new Array();
                        this.state.permisosUsuario.forEach(e => {
                            var regg = almacenes.filter(data => data.id == e.idAlmacen);
                            if (regg.length > 0) {
                                var item = {
                                    direccion: regg[0].direccion,
                                    id: regg[0].id,
                                    idTipoAlmacen: regg[0].idTipoAlmacen,
                                    nombre: regg[0].nombre
                                }
                                newArray.push(item);
                            }

                        });
                        almacenes = newArray;
                    }

                    const listasPrecio = this.state.listasPrecio.filter(
                        (m) => m.idEstablecimiento === value
                    );
                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            almacenLoading: false,
                            almacenes: almacenes ? almacenes : [],
                            listasPrecio: listasPrecio ? listasPrecio : []
                        }
                    });

                }


                form.setFieldsValue({
                    detalleProductos: [],
                    listaComprobanteDetalle: [],
                    listaComprobanteReferencia: [],
                });

            }
        }
    };

    handleBuscarCliente = async (value, form) => {
        this.setState({ formValues: { ...this.state.formValues, clienteLoading: true } });

        //const response = await padronReducidoService.ncnd(value);
        var numberDocument = form.getFieldValue("documentoCliente");
        if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
            dialog.warning(<ul>Ingrese documento valido</ul>);

            return;
        }
        var response = undefined;

        switch (numberDocument.length) {
            case 8:
                response = await padronReducidoService.obtenerDniApi(value);
                break;
            case 11:
                response = await padronReducidoService.obtenerRucApi(value);
                break;
            default:
                response = await padronReducidoService.boleta(value);
                break;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            this.setState({ formValues: { ...this.state.formValues, clienteLoading: false } });

            return;
        }
        var vehiculos = await vehiculoService.obtenerPorClienteId(response.data.idCliente);

        if (response.status === 200) {

            var contactos = response.data.clientes.length == 0 ? [] :
                await contactoService.listarPorIdEntidad(response.data.clientes[0].id);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clienteLoading: false,
                    direcciones: response.data.direcciones,
                    vehiculos: vehiculos ? vehiculos : [],
                    contactos: contactos ? contactos : [],
                    idContacto: 0,
                    documentoCliente: numberDocument
                }
            }, () => {
                form.setFieldsValue({
                    clientes: response.data.clientes,
                    idCliente: response.data.clientes.length > 0 ? { key: response.data.clientes[0].id } : undefined,
                    idEstablecimientoCliente: response.data.direcciones.length > 0 ? { key: response.data.direcciones[0].id } : undefined,
                    idContacto: undefined
                });
            });

        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clienteLoading: false,
                    direcciones: [],
                }
            }, () => {
                form.setFieldsValue({
                    clientes: [],
                    idCliente: undefined,
                    idEstablecimientoCliente: undefined
                });
            });
        }
    };

    handleOpenSearchProductModal = async () => {
        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var allStock = this.state.onGetFieldValue('flagAlmacen');

        if (idAlmacen === undefined || idAlmacen.key === 0) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        if (idListaPrecio === undefined || idListaPrecio.key === 0) {
            message.warning('Por favor seleccione una lista de precio.');
            return;
        }

        var filter = {
            idAlmacen: allStock ? 0 : idAlmacen.key,
            idListaPrecio: idListaPrecio.key,
            idMoneda: idMoneda.key,
        }
        var response = await productoService.Sinstock(filter);

        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                precioUnitInclyIGV: response.precioUnitInclyIGV,
                dataSource: response.productos
            }
        });
    };

    handleBuscarProducto = async (value, form) => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');
        var allStock = this.state.onGetFieldValue('flagAlmacen');

        var filter = {
            idAlmacen: allStock ? 0 : idAlmacen.key,
            idMoneda: idMoneda.key,
            idListaPrecio: idListaPrecio.key,
            codigoNombre: value
        }

        var response = await productoService.Sinstock(filter);



        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        }, () => {
            form.setFieldsValue({
                dataSource: response.productos
            });
        });
    };

    handleChangeCliente = async (value, form) => {

        var contactos = await contactoService.listarPorIdEntidad(value.key);

        this.setState({
            formValues: {
                ...this.state.formValues,
                contactos: contactos,
            }
        });
    };


    handleSelectProduct = async (row) => {
        var params = auth.user().parametros;
        var idListaPrecio = this.state.onGetFieldValue("idListaPrecio").key;

        var conversionMedida = params.filter((m) => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

        var listaPrecio = 0;
        var itemsConversion = [];
        if (conversionMedida) {
            itemsConversion = await productoService.listarConversionProductoPorId(row.id);
            var lista_data = this.state.listasPrecio.filter((m) => m.id == idListaPrecio);
            listaPrecio = lista_data[0].idTipoListaPrecio;

        }
        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: row.id,
            idTipoProducto: row.idTipoProducto,
            codigo: row.codigoReferencia,
            nombre: row.nombre,
            nombreUnidadMedida: row.nombreUnidadMedida,
            flagAfecto: row.flagIGVAfecto,
            flagGratuito: row.flagGratuito,
            flagISC: row.flagISC,
            isc: 0,
            precioUnitario: row.precioUnitario,
            precioPromedio: row.precioPromedio,
            porcentajeMargenComercial: row.porcentajeMargenComercial,
            cantidad: 0,
            totalDetalle: 0,
            porcentajeDescuento: 0,
            importeDescuento: 0,
            subTotal: 0,
            igv: 0,
            total: 0,
            numeroLote: row.numeroLote,
            stock: 0,
            idUnidadMedida: row.idUnidadMedida,
            idImpuesto: row.idImpuesto,
            itemConversion: itemsConversion ? itemsConversion : [],
            flagConversion: false,
            flagVencimiento: row.flagVencimiento,
            fechaVencimientoStr: row.flagVencimiento ? row.fechaVencimientoStr : null
        };

        listaComprobanteDetalle.push(item);

        this.setState({
            formValues: {
                ...this.state.formValues,
                idTipoPrecio: listaPrecio,
                listaComprobanteDetalle: listaComprobanteDetalle
            }
        }, () => {
            var producto = {
                identifier: item.identifier,
                idProducto: item.idProducto,
                idTipoProducto: row.idTipoProducto,
                nombre: item.nombre,
                cantidad: item.cantidad,
                precioUnitarioSinIGV: 0,
                precioUnitario: item.precioUnitario,
                precioPromedio: item.precioPromedio,
                porcentajeMargenComercial: item.porcentajeMargenComercial,
                porcentajeDescuento: item.porcentajeDescuento,
                importeDescuento: item.importeDescuento,
                total: item.total,
                flagAfecto: item.flagAfecto,
                flagISC: item.flagISC,
                flagOtrosImpuesto: false,
                flagGratuito: item.flagGratuito,
                flagChangeTotal: false,
                subTotal: 0,
                idImpuesto: row.idImpuesto,
                numeroLote: row.numeroLote,
                idUnidadMedida: row.idUnidadMedida,
                itemConversion: itemsConversion ? itemsConversion : [],
                flagConversion: false,
                flagVencimiento: row.flagVencimiento,
                fechaVencimientoStr: row.flagVencimiento ? row.fechaVencimientoStr : null
            };

            var detalleProductos = this.state.onGetFieldValue('detalleProductos');
            detalleProductos.push(producto);
            this.state.onSetFieldsValue({ detalleProductos });
            this.state.onSetFieldsValue({ idTipoPrecio: listaPrecio });

        });
    };

    handleSelectConversion = async (dataItem, value, index, identifier) => {

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle.filter((m) => m.identifier !== identifier);

        var idAlmacen = this.state.onGetFieldValue("idAlmacen");
        var idMoneda = this.state.onGetFieldValue("idMoneda");
        var idListaPrecio = this.state.onGetFieldValue("idListaPrecio");

        var filter = {
            idAlmacen: idAlmacen.key,
            idMoneda: idMoneda.key,
            idListaPrecio: idListaPrecio.key,
            idProducto: dataItem.idProducto,
            idUnidadMedida: value,
            flagConversion: true
        };
        var row = await productoService.stock_conversionMedida(filter);


        dataItem.nombreUnidadMedida = '';
        dataItem.precioPromedio = row[0].precioPromedio;
        dataItem.precioUnitario = row[0].precioUnitario;
        dataItem.cantidad = 0;
        dataItem.precioUnitarioSinIGV = 0;
        dataItem.totalDetalle = 0;
        dataItem.porcentajeDescuento = 0;
        dataItem.importeDescuento = 0;
        dataItem.subTotal = 0;
        dataItem.igv = 0;
        dataItem.total = 0;
        dataItem.idUnidadMedida = value;
        dataItem.stock = row[0].stockDisponible;
        dataItem.flagConversion = true;
        listaComprobanteDetalle.splice(index, 0, dataItem);

        this.setState(
            {
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteDetalle: listaComprobanteDetalle,
                },
            },
            () => {

                var detalleFilter = this.state.onGetFieldValue("detalleProductos");
                var detalleProductos = detalleFilter.filter((m) => m.identifier !== identifier);
                detalleProductos.splice(index, 0, dataItem);
                this.state.onSetFieldsValue({
                    detalleProductos,
                    [`arrPrecioUnitario[${identifier}]`]: dataItem.precioUnitario,

                });
            }
        );
    };

    handleSelectHistorial = async (row, form) => {
        const tienePermiso = this.state.configuraciones.some(m => m.abreviatura === VER_HISTORIAL_COTIZACION);

        if (!tienePermiso) {
            dialog.info('Opción no disponible en su plan actual, contacte a un asesor comercial');
            return;
        }

        var idCliente = form.getFieldValue('idCliente');

        if (idCliente === undefined) {
            message.warning('Por favor seleccione un cliente.');
            return;
        }

        var row = await cotizacionService.verHistorial({ idCliente: idCliente.key, idProducto: row.idProducto });

        this.setState({
            historialSource: row,
            historialVisible: true
        });

    };

    handleScanerProduct = async (value, onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue,
        });
        // dialog.confirm(
        //   "El total de la venta excede el monto máximo establecido ¿Desea continuar?",
        //   async () => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');

        if (idAlmacen === undefined) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        if (idMoneda === undefined) {
            message.warning('Por favor seleccione la moneda.');
            return;
        }

        if (idListaPrecio === undefined) {
            message.warning('Por favor seleccione una lista de precio.');
            return;
        }

        /* PARAMETROS */
        var params = auth.user().parametros;
        var flagPrecioIncluyeIGV =
            params.filter(
                (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
            )[0].valor === "1"
                ? true
                : false;

        var porcentajeIGV = lst_tipo_impuesto.find(item => item.id === this.state.formValues.otroImpuesto)?.value ?? 18;

        /* LSITA */
        var listaComprobanteDetalle = this.state.formValues
            .listaComprobanteDetalle;
        var filter_detalle = listaComprobanteDetalle.filter(
            (m) => m.codigoBarra === value
        );

        var item = {};
        if (filter_detalle.length > 0) {
            listaComprobanteDetalle = listaComprobanteDetalle.filter(
                (m) => m.codigoBarra !== value
            );
            var item = filter_detalle[0];
            item.cantidad = item.cantidad + 1;
        } else {
            var filter = {
                idAlmacen: idAlmacen.key,
                idMoneda: idMoneda.key,
                idListaPrecio: idListaPrecio.key,
                codigoNombre: value,
            };

            var list = await productoService.Sinstock(filter);
            var filter_list = list.productos.filter(
                (m) => m.codigoBarra === value
            );
            if (filter_list.length === 0) {
                alert("no existe el producto");
                return;
            }
            var row = filter_list[0];

            item = {
                identifier: global.fetchUniqueCode(),
                idProducto: row.id,
                idTipoProducto: row.idTipoProducto,
                codigo: row.codigoReferencia,
                codigoBarra: row.codigoBarra,
                nombre: row.nombre,
                nombreUnidadMedida: row.nombreUnidadMedida,
                porcentajeMargenComercial: row.porcentajeMargenComercial,
                precioPromedio: row.precioPromedio,
                flagAfecto: row.flagIGVAfecto,
                flagGratuito: row.flagGratuito,
                flagISC: row.flagISC,
                flagExonerado: row.flagExonerado,
                isc: 0,
                precioUnitario: row.precioUnitario,
                cantidad: 1,
                totalDetalle: 0,
                porcentajeDescuento: 0,
                importeDescuento: 0,
                subTotal: 0,
                igv: 0,
                total: 0,
                numeroLote: row.numeroLote,
                stock: row.stockDisponible,
            };
        }

        /* CALCULOS */
        var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
        item.precioUnitarioSinIGV = flagPrecioIncluyeIGV
            ? item.precioUnitario / divisorCalculoSubTotal
            : item.precioUnitario;
        item.totalDetalle = item.cantidad * item.precioUnitarioSinIGV;
        item.subTotal = item.cantidad * item.precioUnitarioSinIGV;
        item.igv = parseFloat(
            item.flagAfecto ? item.subTotal * (porcentajeIGV / 100) : 0
        );
        item.total = item.subTotal + item.igv;
        /* CALCULOS */

        listaComprobanteDetalle.push(item);

        this.setState(
            {
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteDetalle: listaComprobanteDetalle,
                },
            },
            () => {

                var producto = {
                    identifier: item.identifier,
                    idProducto: item.idProducto,
                    idTipoProducto: item.idTipoProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    precioUnitarioSinIGV: item.precioUnitarioSinIGV,
                    porcentajeMargenComercial: item.porcentajeMargenComercial,
                    precioPromedio: item.precioPromedio,
                    precioUnitario: item.precioUnitario,
                    porcentajeDescuento: item.porcentajeDescuento,
                    importeDescuento: item.importeDescuento,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    flagExonerado: item.flagExonerado,
                    flagISC: item.flagISC,
                    flagOtrosImpuesto: false,
                    flagGratuito: item.flagGratuito,
                    flagChangeTotal: false,
                    subTotal: 0,
                    numeroLote: item.numeroLote,
                };


                var detalleProductos = this.state.onGetFieldValue(
                    "detalleProductos"
                );
                detalleProductos = detalleProductos.filter(
                    (m) => m.identifier !== producto.identifier
                );
                detalleProductos.push(producto);
                this.state.onSetFieldsValue({
                    sumaTotalDetalle: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["totalDetalle"] || 0),
                        0
                    ),
                    sumaSubTotal: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["subTotal"] || 0),
                        0
                    ),
                    sumaIgv: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["igv"] || 0),
                        0
                    ),
                    sumaTotal: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["total"] || 0),
                        0
                    ),
                    detalleProductos: detalleProductos,
                });
            }
        );
        //   }
        // );
    };

    handleRemoverProducto = (row, form) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== row.identifier)
            },
        }, () => {
            var detalleProductos = form.getFieldValue('detalleProductos');
            form.setFieldsValue({
                detalleProductos: detalleProductos.filter(m => m.identifier !== row.identifier)
            });
        });
    };

    handleEditarNombreProducto = (row, onSetFieldsValue, onGetFieldValue) => {
        var formValues = {
            id: row.identifier,
            nombre: onGetFieldValue(`arrNombre[${row.identifier}]`)
        };

        this.setState({
            editarNombreProductoVisible: true,
            editarNombreProductoFormValues: formValues,
            onSetFieldsValue,
            onGetFieldValue
        });
    };

    handleSaveEditarNombreProducto = (values, form) => {
        form.resetFields();
        this.setState({ editarNombreProductoVisible: false });
        var detalleProductos = this.state.onGetFieldValue("detalleProductos");
        detalleProductos.forEach(item => {
            if (item.identifier === values.id) {
                item.nombre = values.nombre;
                return;
            }
        });

        this.state.onSetFieldsValue({
            detalleProductos,
            [`arrNombre[${values.id}]`]: values.nombre
        });
    };

    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: global.fetchUniqueCode(),
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            serie: "",
            documento: "",
            flagInterno: false
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (item) => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== item.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleChangeTab = (key, onSetFieldsValue) => {
        if (key == "2") { // Referencias
            onSetFieldsValue({
                flagReferencia: true
            })
        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, () => {
            if (this.state.formValues.activeKey === "1")
                this.handleOpenSearchProductModal();

            const newLocal = "2";
            if (this.state.formValues.activeKey === newLocal)
                this.handleAddReferencia();
        });
    };

    handleAnular = async (item) => {
        dialog.confirm(`¿Desea anular la cotización ${item.serie}-${item.documento}?`, async () => {
            var response = await cotizacionService.anular({ id: item.id });

            if (response.status === 200) {
                dialog.success(`Cotización ${item.serie}-${item.documento} anulado correctamente.`);
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleAprobar = async (item) => {
        dialog.confirm(`¿Desea aprobar la cotización ${item.serie}-${item.documento}?`, async () => {
            var response = await cotizacionService.aprobar({ id: item.id });

            if (response.status === 200) {
                dialog.success(`Cotización ${item.serie}-${item.documento} aprobado correctamente.`);
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleEditCondicion = async (onSetFieldsValue, onGetFieldValue) => {
        var formValues = {
            id: this.state.formValues.id,
            condicionComercial: this.state.formValues.condicionComercial
        };


        this.setState({
            editarCondicionVisible: true,
            editarCondicionComercial: formValues,
            onSetFieldsValue,
            onGetFieldValue
        });
    };

    handleSaveEditarCondicion = (values, form) => {
        form.resetFields();
        this.setState({ editarCondicionVisible: false });
        this.state.onSetFieldsValue({
            condicionComercial: values.condicionComercial
        });
    };



    async componentDidMount() {
        this._isMounted = true;
        var idUsuario = auth.user().id;
        const empresa = await empresaService.obtenerPrincipal(0);

        const datosIniciales = await this.obtenerDatosIniciales();

        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: VENTA });
        var flagSerie = configuraciones.filter((m) => m.abreviatura === VER_SERIES_VENTA).length >= 1 ? true : false;

        const serie = [undefined, null].includes(datosIniciales?.serie) ? flagSerie ? '' : '-' : datosIniciales.serie;

        this.setState({ filter: { ...this.state.filter, serie } });

        this._initPagination({ ...this.state.filter, serie }, cotizacionService.paginacion);

        const permisosUsuario = await usuarioService.usarioEstablecimiento(auth.user().id, 1)


        const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const listasPrecio = await listaPrecioService.listar();
        const establecimientos = await establecimientoService.principales();
        const vendedores = await vendedorService.listar();
        const tiposComprobante = await tipoComprobanteService.listar();
        const detracciones = await detraccionService.listar();
        const clientes = await clienteService.listar();
        const proyectos = await proyectoService.listar();
        const estado = await cotizacionService.listarEstado();
        const cultivos = await cultivoService.listar();



        if (this._isMounted) {
            this.setState({
                loadingSource: false,
                tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
                monedas: monedas ? monedas : [],
                listasPrecio: listasPrecio ? listasPrecio : [],
                establecimientos: establecimientos ? establecimientos : [],
                vendedores: vendedores ? vendedores : [],
                tiposComprobante: tiposComprobante ? tiposComprobante : [],
                detracciones: detracciones ? detracciones : [],
                clientes: clientes ? clientes : [],
                proyectos: proyectos ? proyectos : [],
                estado: estado ? estado : [],
                configuraciones: configuraciones ? configuraciones : [],
                permisosUsuario: permisosUsuario ? permisosUsuario : [],
                cultivos: cultivos ? cultivos : [],
                company: empresa
            });
        }
    };


    obtenerDatosIniciales = async () => {
        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: COTIZACION.ID
        }
        const datosIniciales = await cotizacionService.datosIniciales(datosInicialesFilter);

        return datosIniciales;
    }


    componentWillUnmount() {
        this._isMounted = false;
    };

    render() {
        return (
            <div>
                <Header
                    title="Cotización"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource || this.state.loadingNew}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    lista_clientes={this.state.clientes}
                    estado={this.state.estado}
                    proyectos={this.state.proyectos}
                    configuraciones={this.state.configuraciones}
                    vendedores={this.state.vendedores}


                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingEdit || this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingCopy={this.state.loadingCopy}
                    loadingImprimir={this.state.loadingImprimir || this.state.loadingSource}
                    claim={this.state.company?.idTipoEmpresa === 2}
                    onPrint={this.handlePrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onEdit={this.handleEdit}
                    onCopy={this.handleCopy}
                    onChange={this._handleChangePagination}
                    onView={this.handleView}
                    onAnular={this.handleAnular}
                    onAprobar={this.handleAprobar}

                    onImprimir={this.handleImprimir}
                    onCorreo={this.handleCorreo}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarCliente={this.handleBuscarCliente}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onEditarNombreProducto={this.handleEditarNombreProducto}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onScanerProduct={this.handleScanerProduct}
                    handleSelectConversion={this.handleSelectConversion}
                    handleHistorialProducto={this.handleSelectHistorial}
                    onChangeCliente={this.handleChangeCliente}
                    onEditCondicion={this.handleEditCondicion}

                />

                <FormHistorial
                    visible={this.state.historialVisible}
                    dataSource={this.state.historialSource}
                    onClose={() => this.setState({ historialVisible: false })}
                    onSend={this.handleEnviarCorreo}
                />


                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onSwitch={this.handleSwitch}
                    onDownload={this.handleDownloadPdf}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />
                <CorreoModal
                    visible={this.state.correoVisible}
                    formValues={this.state.correoFormValues}
                    onClose={() => this.setState({ correoVisible: false })}
                    onSend={this.handleEnviarCorreo}
                />
                <SearchProductModal
                    onBuscarProducto={this.handleBuscarProducto}
                    visible={this.state.searchProductVisible}
                    validarStock={this.state.searchProductFormValues.validarStock}
                    precioUnitInclyIGV={this.state.searchProductFormValues.precioUnitInclyIGV}

                    dataSource={this.state.searchProductFormValues.dataSource}
                    dataSourceAgregado={this.state.formValues.listaComprobanteDetalle}
                    onSelect={this.handleSelectProduct}
                    onCancel={() => this.setState({ searchProductVisible: false })}
                />
                <EditarNombreProductoModal
                    visible={this.state.editarNombreProductoVisible}
                    formValues={this.state.editarNombreProductoFormValues}
                    onClose={() => this.setState({ editarNombreProductoVisible: false })}
                    onSave={this.handleSaveEditarNombreProducto}
                />
                <ViewModal
                    visible={this.state.viewVisible}
                    formValues={this.state.viewFormValues}
                    onClose={() => this.setState({ viewVisible: false })}
                />

                <CondicionComercialModal
                    visible={this.state.editarCondicionVisible}
                    formValues={this.state.editarCondicionComercial}
                    onClose={() => this.setState({ editarCondicionVisible: false })}
                    onSave={this.handleSaveEditarCondicion}
                />
            </div>
        )
    }
}